import { Nav } from 'react-bootstrap';
import profileAnmination from "../../../animations/header_lottie_btn_animation/Profile_lottie_btn_animation.json";
import Header_lottie_btn from '../../../common_components/common_btn/header_lottie_btn/Header_lottie_btn';
import "./Profile_all_tabs.css";

function Profile_all_tabs() {
    return (
        <>
            <section className='Profile_all_tabs'>
                <div className="profile_card">
                    <div className="profile_icon">
                        <Header_lottie_btn animationData={profileAnmination} />
                    </div>
                    <div>
                        <p className="profile_id">
                            Hello
                        </p>
                        <h6 className="profile_name">Pratiksha </h6>
                    </div>
                </div>

                <Nav variant="pills" className="flex-column">
                    <Nav.Item>
                        <Nav.Link eventKey="personal-details">Personal Details</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="password">Password</Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link eventKey="kyc">KYC</Nav.Link>
                    </Nav.Item>

                    <Nav.Item>
                        <Nav.Link eventKey="bank-details">Bank Details</Nav.Link>
                    </Nav.Item>
                </Nav>
            </section>
        </>
    )
}

export default Profile_all_tabs